import * as Sentry from '@sentry/react';
import { setUserStore } from '@/entities/user';
import { createRootRoute, Outlet } from '@tanstack/react-router';
import { LoadingScreen, SidebarProvider } from '@drisk-ai/ui';
import { BackgroundExportFileProvider } from '@drisk-ai/export-file';
import { NotFoundPage } from '@/pages/not-found';
import { getAccessToken } from '@/shared/utils/token.utils';
import { appDataStore, setAppDataStore } from '@/entities/app-data';
import { getCurrentLocation } from '@/shared/integrations/google-places';
import { useStore } from '@tanstack/react-store';
import {
  initAppDataStore,
  initUserDataStore,
} from '@/features/global-storage/init';

let isAuthInitialized = false;

export const Route = createRootRoute({
  beforeLoad: async () => {
    getCurrentLocation()
      .then(userCurrentAddress => {
        setAppDataStore({ userCurrentAddress });
      })
      .catch(e => {
        console.error('Failed to get current location:', e);
      });

    if (!isAuthInitialized) {
      isAuthInitialized = true;

      try {
        if (getAccessToken()) {
          await initUserDataStore();
          await initAppDataStore();
        }
      } catch {
        setUserStore(null);
      }
    }
  },

  component: RootComponent,
  notFoundComponent: NotFoundPage,
});

function RootComponent() {
  const { isContextSwitching } = useStore(appDataStore);

  return (
    <BackgroundExportFileProvider>
      <Sentry.ErrorBoundary fallback={<p>An error has occurred</p>}>
        <SidebarProvider>
          <Outlet />
          {isContextSwitching ? (
            <LoadingScreen className="fixed inset-0 z-[1000] bg-black/35" />
          ) : null}
        </SidebarProvider>
      </Sentry.ErrorBoundary>
    </BackgroundExportFileProvider>
  );
}
